<div class="title" *ngIf="gatewayCommissioningStore.selectedDevice$ | async as selectedDevice">
  {{
    selectedDevice === deviceType.VITOCONNECT
      ? ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ADDRESS_FORM.VITOCONNECT.HEADER' | translate)
      : ('+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ADDRESS_FORM.ONE_BASE.HEADER' | translate)
  }}
</div>

<div
  class="full-width flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start"
>
  <div class="lt-md:!hidden flex-[100%] max-w-[50%]"></div>

  <form [formGroup]="addressFormGroup" class="forms-container flex-1" data-at-provide-gw-serial>
    <div class="field-row flex flex-row gap-[10px]">
      <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]">
        <mat-label>{{ '+USER_DETAILS.PERSONAL_DETAILS.STREET' | translate }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="address-street"
          gtmAction="Address street"
          gtmCategory="gatewayCommissioningAddressForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="street"
          formControlName="street"
          data-at-street-input
          matInput
          required
        />
        <mat-error *ngIf="addressFormGroup.controls.street?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.STREET.ERROR.REQUIRED' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row flex flex-row gap-[10px]">
      <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HOUSE_NUMBER.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="address-house-number"
          gtmAction="Address house number"
          gtmCategory="gatewayCommissioningAddressForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="houseNumber"
          formControlName="houseNumber"
          matInput
          data-at-house-number-input
          required
        />
        <mat-error *ngIf="addressFormGroup.controls.houseNumber?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.HOUSE_NUMBER.ERROR.REQUIRED' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row flex flex-row gap-[10px]">
      <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ZIP_CODE.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="address-zip"
          gtmAction="Address zip"
          gtmCategory="gatewayCommissioningAddressForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="zip"
          formControlName="zip"
          data-at-zip-input
          matInput
          required
        />
        <mat-error *ngIf="addressFormGroup.controls.zip?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.ZIP_CODE.ERROR.REQUIRED' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row flex flex-row gap-[10px]">
      <mat-form-field mat-input-height-large-label class="flex-[100%] max-w-[100%]">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.CITY.PLACEHOLDER' | translate
        }}</mat-label>
        <input
          gtm="onTextField"
          gtmId="address-city"
          gtmAction="Address city"
          gtmCategory="gatewayCommissioningAddressForm"
          [gtmOn]="['change', 'focus', 'blur']"
          name="city"
          formControlName="city"
          data-at-city-input
          matInput
          required
        />
        <mat-error *ngIf="addressFormGroup.controls.city?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.CITY.ERROR.REQUIRED' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row flex flex-row gap-[10px]" *ngIf="supportedCountries.length > 0">
      <mat-form-field mat-select-height-large class="flex-[100%] max-w-[100%]">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.COUNTRY.PLACEHOLDER' | translate
        }}</mat-label>
        <span
          matPrefix
          *ngIf="selectedCountry?.country"
          class="flag flag-{{ selectedCountry.countryCode | lowercase }}"
        ></span>
        <mat-select
          data-at-country-select
          (selectionChange)="onCountryChanged($event)"
          name="country"
          formControlName="country"
          [placeholder]="country"
          required
        >
          <mat-option
            gtm="onSelect"
            gtmAction="Country"
            gtmCategory="gatewayCommissioningAddressForm"
            *ngFor="let country of supportedCountries"
            [value]="country.countryCode"
            [attr.data-at-country]="country.countryCode"
          >
            <span class="flag flag-{{ country.countryCode | lowercase }}"></span
            >{{ country.country | translate }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="addressFormGroup.controls.country?.errors?.required">{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.COUNTRY.ERROR.REQUIRED' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
    <div class="field-row flex flex-row gap-[10px]" *ngIf="selectedCountry?.regions?.length">
      <mat-form-field mat-select-height-large class="flex-[100%] max-w-[100%]">
        <mat-label>{{
          '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.REGION.PLACEHOLDER' | translate
        }}</mat-label>
        <mat-select data-at-region-select name="region" formControlName="region">
          <mat-option
            gtm="onSelect"
            gtmAction="Country"
            gtmCategory="gatewayCommissioningAddressForm"
            value=""
            >{{ NO_VALUE }}
          </mat-option>
          <mat-option
            gtm="onSelect"
            gtmAction="Country"
            gtmCategory="gatewayCommissioningAddressForm"
            *ngFor="let region of selectedCountry.regions"
            [value]="selectedCountry.countryCode + '-' + region.shortCode"
          >
            {{ region.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>
